import { colors } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp } from 'styled-components';
import { CensusStepSectionStyled } from '../CensusStepSectionStyled';

export const InValidCensusSectionStyled = styled(CensusStepSectionStyled)<{ $disabled: boolean }>`
  ${({ $disabled }): CSSProp =>
    $disabled
      ? `
         border: 2px solid ${colors.neutral[300]}
        `
      : `
         border: 2px solid ${colors.orange[600]}
        `}
`;
